import { css } from '@emotion/css';
import React from 'react';
import { MAX_DESKTOP_WIDTH_REM, mqBreakpoints } from '../../system-libraries/styles';
import { pxToRem } from '../../system-libraries/styles/utils';
import Config from '../../system-utils/config-manager';
import { pushState } from '../../system-utils/url-utils';

const onMarketplaceClick: React.MouseEventHandler = e => {
  e.preventDefault();
  pushState(Config.get('paths.marketplace.root'));
};

export const UtilityNav: React.FC = () => {
  return (
    <div className={styles.utilityNav} data-testid='nba-utilitynav'>
      <div className={styles.container}>
        <div className={styles.buttonsContainer}>
          <a className={styles.button} onClick={onMarketplaceClick} data-testid='nba-utilitynav-back-to-marketplace' href={Config.get('login_and_registration.url')}>
            <img src={Config.get('image_cdn_base_url') + '/ui/shared-component-webapp/utility-bar/chevron-left.svg'} className={styles.icon} /> Back to Marketplace
          </a>
        </div>
      </div>
    </div>
  );
};

const styles = {
  utilityNav: css({
    flexShrink: 0,
    height: pxToRem(80),
    margin: '0 auto',
    width: '100%',
  }),
  container: css({
    margin: '0 auto',
    height: pxToRem(80),
    color: 'var(--color-body)',
    fontSize: pxToRem(18),
    display: 'flex',
    flexDirection: 'row',
    paddingLeft: pxToRem(16),
    paddingRight: pxToRem(16),
    maxWidth: MAX_DESKTOP_WIDTH_REM,

    [mqBreakpoints.tablet]: {
      paddingLeft: pxToRem(48),
      paddingRight: pxToRem(48),
    },
    [mqBreakpoints.desktop]: {
      paddingLeft: pxToRem(80),
      paddingRight: pxToRem(80),
    },
  }),
  buttonsContainer: css({
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    justifyContent: 'flex-start',
    alignItems: 'center',
    color: 'var(--color-body)',
  }),
  icon: css({
    marginRight: pxToRem(16),
    maxWidth: pxToRem(7),
    maxHeight: pxToRem(12),

    [mqBreakpoints.tablet]: {
      marginLeft: pxToRem(0),
      maxWidth: pxToRem(8),
      maxHeight: pxToRem(14),
    },
    [mqBreakpoints.desktop]: {
      maxWidth: pxToRem(14),
      maxHeight: pxToRem(16),
    },
  }),
  button: css({
    alignItems: 'center',
    display: 'flex',
    color: 'var(--color-body)',
    flexDirection: 'row',
    textAlign: 'center',
    textDecoration: 'none',
  }),
};
